import React, { Component } from 'react';

import Routes from './Route';

class App extends Component {
  render() {
    return (
      <Routes />
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js